import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import background from "../../assets/background.webp";
import { useAccessibility } from "../../accessibility/core/useAccessibility";

export function Hero() {
  const { state } = useAccessibility();
  const reduceMotion = state?.reduceMotion;

  return (
    <section
      aria-labelledby="hero-title"
      className="relative min-h-[90vh] flex  md:items-center justify-center overflow-hidden pt-14 md:pt-20"
    >
      {/* Background Image */}
      <img
        src={background}
        alt=""
        fetchPriority="high"
        className="absolute inset-0 w-full h-full object-cover object-[30%_40%] md:object-center"
      />

      <div className="absolute inset-0 bg-gradient-to-r from-slate-950/80 via-slate-950/50 to-transparent md:hidden" />

      {/* Dark Professional Overlay */}
      <div aria-hidden="true" className="absolute inset-0 bg-slate-950/40" />

      {/* Blue Cinematic Glow */}
      <div
        aria-hidden="true"
        className="absolute inset-0 bg-[radial-gradient(circle_at_60%_50%,rgba(59,130,246,0.18),transparent_65%)]"
      />

      {/* Content */}
      <div className="container mx-auto px-6 relative z-10 pt-8 md:pt-0">
        <div className="max-w-4xl mx-auto text-center md:text-right">
          <motion.h1
            id="hero-title"
            aria-describedby="hero-description"
            initial={reduceMotion ? false : { opacity: 0, y: 30 }}
            animate={reduceMotion ? { opacity: 1 } : { opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
            className="text-5xl md:text-7xl lg:text-8xl font-bold text-slate-100 leading-[1.1] mb-8 tracking-tight"
          >
            הסיפור שלך <br />
            <span className="text-slate-400">המאבק שלנו.</span>
          </motion.h1>
          <p className="text-slate-400 text-lg mb-4 tracking-wide">
            מלווה לקוחות בתחום הנזיקין והביטוח{" "}
            <span className="text-white font-semibold">משנת 2007</span>
          </p>

          <motion.p
            id="hero-description"
            initial={reduceMotion ? false : { opacity: 0, y: 30 }}
            animate={reduceMotion ? { opacity: 1 } : { opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4, ease: "easeOut" }}
            className="text-xl md:text-2xl text-slate-300 mb-10 max-w-2xl mx-auto md:mr-0 leading-relaxed font-light"
          >
            משרד עורכי דין ארז עזרא – <br />
            <span className="text-slate-200 font-medium">
              מלווים אותך למיצוי זכויותיך המשפטיות.{" "}
            </span>
          </motion.p>

          <motion.nav
            aria-label="פעולות מרכזיות"
            initial={reduceMotion ? false : { opacity: 0, y: 30 }}
            animate={reduceMotion ? { opacity: 1 } : { opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6, ease: "easeOut" }}
            className="flex flex-col md:flex-row gap-4 justify-center md:justify-start"
          >
            <a
              href="#contact"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-blue-600 text-white text-lg font-medium rounded-full hover:bg-blue-500 transition-all shadow-lg hover:shadow-blue-500/30 hover:scale-105 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
            >
              תיאום פגישת ייעוץ
              <ArrowLeft size={20} />
            </a>
            <a
              href="#about"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-slate-800 text-slate-200 text-lg font-medium rounded-full hover:bg-slate-700 transition-all border border-slate-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
            >
              הכירו את עו״ד ארז עזרא
            </a>
          </motion.nav>
        </div>
      </div>
    </section>
  );
}
